export enum OTPStatuses {
  AddDemographics = 1,
  OTPOk = 2,
  Locked = 3,
  NotFound = 4,
  Error = 5,
}
